import { createRoot } from "react-dom/client";
import { Modal } from "bootstrap";

export default function ConfirmText(options, cb) {

	let shown = true;

	const cancelled = () => {
		container.off('hide.bs.modal').off('shown.bs.modal');
		container.remove();
	}

	const confirmed = () => {
		let val = $('#confirmText').val();
		if (!val) {
			$('#confirmText').focus();
			return;
		}
		shown = false;
		modal.hide();
		cb(val);
	}

	const container = $('<div class="modal fade" tabindex="-1"><div class="modal-dialog modal-dialog-centered"></div></div>');
	$('body').append(container);
	const modalContent = $('.modal-dialog', container)[0];
	const modal = new Modal(container);
	container
		.on('hide.bs.modal', cancelled)
		.on('shown.bs.modal', () => $('#confirmText').focus().select());
	createRoot(modalContent).render(
		<div className="modal-content">
			<div className="modal-body text-center">
				<fieldset>
					<legend>{options.text ?? t.commonConfirm}</legend>
					<div className="form-control-wrap">
						<textarea required className="form-control" id="confirmText" defaultValue={options.default ?? ''} />
					</div>
				</fieldset>
			</div>
			<div className="modal-footer bg-light">
				<button onClick={confirmed} type="button" className="btn btn-primary">{options.button ?? t.commonSend}</button>
			</div>
		</div>);

	modal.show();
}